<template>
  <div :class="classes">
    <div class="savings-display__row lnx-row lnx-no-gutters">
      <div class="lnx-col-9 savings-display__label">{{ $t('result.total_savings_label') }}:</div>
      <div class="lnx-col-3 savings-display__value">
        <span v-if="showIsLoading">{{ formatPrice(props.savings!) }}</span>
        <span
          v-else
          class="savings-display__invalid"
          role="img"
          :aria-label="$t('result.total_savings_unavailable')"
          :title="$t('result.total_savings_unavailable')"
        ></span>
      </div>
    </div>

    <div class="savings-display__row lnx-row lnx-no-gutters">
      <div class="lnx-col-9 savings-display__label">{{ $t('result.total_savings_percentage_label') }}:</div>
      <div class="lnx-col-3 savings-display__value">
        <span v-if="showIsLoading">{{ formatPercentage(props.savingsPercentage!) }}</span>
        <span
          v-else
          class="savings-display__invalid savings-display__invalid-percentage"
          role="img"
          :aria-label="$t('result.total_savings_percentage_unavailable')"
          :title="$t('result.total_savings_percentage_unavailable')"
        ></span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { formatPercentage, formatPrice } from '@/services/helper.service.ts'
import { computed } from 'vue'
import { isNotNullish } from '@/helpers/type-checks.ts'
import type { ASavingsDisplayProps } from './a-savings-display-props'

const props = defineProps<ASavingsDisplayProps>()

const showIsLoading = computed(
  () => props.isValid && !props.isLoading && isNotNullish(props.savingsPercentage) && isNotNullish(props.savings)
)

const classes = computed(() => {
  return {
    'savings-display': true,
    'savings-display__is-loading': props.isLoading,
    'savings-display__is-valid': props.isValid
  }
})
</script>

<style lang="scss" scoped>
@import 'a-savings-display';
</style>
